<template>
  <!-- deprecated -->
  <vb-modal
    :value="isVisible"
    :show-loading="showLoading"
    :class="{ 'is-large': large, 'is-xlarge': xlarge }"
    :show-header="showHeader"
    @cancel="close()"
  >
    <div slot="modal-header" class="modal-header">
      <slot name="modal-header">
        {{ title }}
      </slot>
    </div>

    <div slot="modal-body" class="modal-body">
      <slot name="modal-body">
        Body content [Modal]
      </slot>
    </div>

    <div slot="modal-footer" class="modal-footer">
      <slot name="modal-footer">
        <button type="button" class="btn btn-default" @click="close()">
          {{ closeText }}
        </button>
        <button
          v-if="hasOkButton"
          type="button"
          class="btn btn-primary"
          @click="ok()"
        >
          {{ okText }}
        </button>
      </slot>
    </div>
  </vb-modal>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Title' },
    showLoading: { type: Boolean, default: false },
    okText: { type: String, default: 'Save' },
    closeText: { type: String, default: 'Close' },
    focusOnFirstInput: { type: Boolean, default: true },
    large: { type: Boolean, default: false },
    xlarge: { type: Boolean, default: false },
    hasOkButton: { type: Boolean, default: true },
    showHeader: { type: Boolean, default: true },
  },
  data() {
    return {
      isVisible: false,
    }
  },
  watch: {
    isVisible(newValue) {
      if (newValue) {
        this.$emit('open')
      } else {
        this.$emit('close')
      }
    },
  },
  methods: {
    open() {
      this.isVisible = true
      this.$nextTick(function () {
        const inputs = this.$el.getElementsByTagName('input')
        if (inputs.length) {
          inputs[0].focus()
        }
      })
    },
    close() {
      this.isVisible = false
    },
    closeAndRedirect(route) {
      this.close()
      const self = this
      // we need to close modal before we redirect the user as when
      // modal is shown, vertical scroll bar is hidden and re-shown again
      // only after modal is closed
      // am not happy with this solution but it should enough for now
      setTimeout(function () {
        self.$router.push(route)
      }, 500)
    },
    ok() {
      this.$emit('ok')
    },
  },
}
</script>
